module.exports = __webpack_public_path__ + "static/assets/89caeee13c05b32bd0b62a5d6230fd97.png";